import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VersionPath } from 'app/core/common';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AvailabilityRequest, AvailabilityResponse } from '../../../shared/searcher/models/availability.models';
import { PathAvailabilityManager } from './models/path-availability.enum';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityLayerApi {
  private readonly _httpClient = inject(HttpClient);

  public getLowPrices(request: AvailabilityRequest): Observable<AvailabilityResponse[]> {
    const url = `${environment.btbBFF.bav.baseUrl}/${environment.btbBFF.bav.nameApi}/${VersionPath.Version1}/${PathAvailabilityManager.Availability}/${PathAvailabilityManager.Search}/${PathAvailabilityManager.LowPrices}`;
    return this._httpClient.post<AvailabilityResponse[]>(url, request);
  }
}
